@use "ui/styles/colorsOld";

.wrapper {
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
